import { ActivatedRoute, ActivatedRouteSnapshot, PRIMARY_OUTLET } from "@angular/router";

export function getDeepestPrimaryRoute(snapshot: ActivatedRouteSnapshot): ActivatedRouteSnapshot {
    let route = snapshot;
    while (route.firstChild) {
        route = route.children.find(child => child.outlet === PRIMARY_OUTLET) ?? route.firstChild
    }
    return route;
}

export function getDeepestPrimaryRouteFromActiveRoute(snapshot: ActivatedRoute): ActivatedRoute {
    let route = snapshot;
    while (route.firstChild) {
        route = route.children.find(child => child.outlet === PRIMARY_OUTLET) ?? route.firstChild
    }
    return route;
}